// This file is web-only and used to scroll into view when a value changes.
import { useEffect, useRef } from "react";
import { Platform, View } from "react-native";

export const useScrollIntoMiddleOnValueChange = <T>({
  value,
  targetRef,
}: {
  value: T | null | undefined;
  targetRef: React.RefObject<View | null>;
}) => {
  const prevValueRef = useRef<T | null | undefined>(undefined);
  const isInitialMountRef = useRef(true);

  useEffect(() => {
    if (isInitialMountRef.current) {
      isInitialMountRef.current = false;
      prevValueRef.current = value;
      return;
    }

    const hasValueChanged = prevValueRef.current !== value;
    const hasValue = value !== null && value !== undefined;

    if (hasValue && hasValueChanged) {
      requestAnimationFrame(() => {
        const target = targetRef.current;
        if (!target) return;

        if (Platform.OS === "web") {
          const targetElement = target as unknown as HTMLElement;
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      });
    }

    prevValueRef.current = value;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
};
